// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"33194a4a","239":"35458d97","396":"7e4da7b5","453":"da614a5d","455":"6e7130fe","977":"19719022"}[chunkId] + ".chunk.js";
};